const Tab = ({ children }) => children;
Tab.displayName = "Tab";
export default Tab;
